import { DeleteButton, DeleteButtonProps } from '@refinedev/antd';
import { Tooltip } from 'antd';

import { usePermissionContext } from '@/contexts/PermissionContext';

interface ProtectedDeleteButtonProps extends DeleteButtonProps {
  tooltip?: string;
}

const ProtectedDeleteButton = (props: ProtectedDeleteButtonProps) => {
  const { hasPermission } = usePermissionContext();

  return hasPermission('delete') ? (
    <Tooltip title={props.tooltip ?? ''}>
      <DeleteButton className="ProtectedDeleteButton" {...props} />
    </Tooltip>
  ) : null;
};

export default ProtectedDeleteButton;
